import { ClientPaymentsHeader, ClientPaymentsList } from './ClientPaymentsList';

export { ClientPaymentsList, ClientPaymentsHeader };
